// Uygulama içi geri gezinme kuralları ("← Geri" butonu).
// React Router (BrowserRouter) her geçmiş girişine window.history.state içinde sıra numarası
// (idx) yazar: ilk açılan sayfa 0'dır. Hangi idx'te hangi sayfanın olduğunu burada (sekme
// oturumu boyunca) not ederiz ki "bir önceki sayfa" ne, bilelim.
//
// Geri GİDİLMEZ:
//   - ilk sayfadaysak (idx 0) — geri gitmek uygulamadan çıkarır,
//   - önceki sayfa bilinmiyorsa,
//   - önceki sayfa giriş/kayıt/şifremi unuttum ise — giriş sayfası açılırken misafir oturumu
//     alıp kullanıcının oturumunu düşürüyor; ilk girişten sonra "Geri" ÇIKIŞ yaptırıyordu.
//     Bu sayfada buton hiç GÖSTERİLMEZ (backButtonAction).

const STORAGE_KEY = "troy.navHistory";
const MAX_ENTRIES = 300;
const AUTH_PATHS = new Set(["/", "/signup", "/forgot-password"]);

export function isAuthPath(pathname) {
  return AUTH_PATHS.has(String(pathname || ""));
}

function historyIndex(historyState) {
  const idx = Number(historyState?.idx);
  return Number.isInteger(idx) && idx >= 0 ? idx : null;
}

function defaultStorage() {
  try { return window.sessionStorage; } catch (e) { return null; }
}

function readMap(storage) {
  if (!storage) return {};
  try {
    const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (e) {
    return {};
  }
}

// O anki geçmiş girişinin hangi sayfa olduğunu not eder (her gezinmede çağrılır).
export function recordHistoryEntry(historyState, pathname, storage = defaultStorage()) {
  const idx = historyIndex(historyState);
  if (idx === null || !storage) return;
  const map = readMap(storage);
  map[idx] = String(pathname || "");
  // Sınırsız büyümesin: yalnız son MAX_ENTRIES giriş tutulur.
  const keys = Object.keys(map).map(Number).filter(Number.isInteger).sort((a, b) => a - b);
  keys.slice(0, Math.max(0, keys.length - MAX_ENTRIES)).forEach((k) => { delete map[k]; });
  try { storage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) { /* kota/erişim: yoksay */ }
}

export function previousInAppPath(historyState, storage = defaultStorage()) {
  const idx = historyIndex(historyState);
  if (idx === null || idx === 0) return null;
  const prev = readMap(storage)[idx - 1];
  return typeof prev === "string" && prev !== "" ? prev : null;
}

export function canGoBackInApp(historyState, storage = defaultStorage()) {
  const prev = previousInAppPath(historyState, storage);
  return prev !== null && !isAuthPath(prev);
}

// "← Geri" butonu ne yapar: "back" (bir önceki sayfaya), "home" (anasayfaya) ya da null (GÖSTERİLMEZ).
// Gösterilmez: girişten hemen sonraki sayfada (önceki kayıt giriş/kayıt ekranı — ilk girişte buton
// işlevsizdi) ve geri gidilecek sayfa yokken anasayfada. Önceki sayfa bilinmiyorsa (yenileme,
// doğrudan bağlantı) anasayfaya götürür.
export function backButtonAction(historyState, pathname, storage = defaultStorage()) {
  const prev = previousInAppPath(historyState, storage);
  if (prev !== null) return isAuthPath(prev) ? null : "back";
  return pathname === "/homepage" ? null : "home";
}
